<script>
export default {
    name: "MpesaPayReport",

    data() {

        return {
            filter: {
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
                groupID: 0,
                search: ``,
            },
            showitemmodal:false,
            invoices: [],
              itemdetails: [],
            organizations: [],
            combinedInvoiceDetails: {
                combinedPaymentnInvoiceDetails: [],
                combinedPaymentnInvoiceItemsDetails: [],
            },
        };
    },

    components: {

        "view-payment-details": () => import('./modals/PreviewSummary.vue'),
          },

    methods: {
        async fetchInvoiceDetails(invoice) {
            this.$root.loading = true;

            try {

                await Promise.all([
                   this.fetchCombinedPayments(invoice),
                    this.fetchOrganizations(invoice),
                ]);
                this.$root.loading = false;

                return Promise.resolve();
            } catch {
                this.$root.loading = false;

                return Promise.reject();
            }
        },
        fetchOrganizations(invoice) {
            let url = `PatientRegistration/GetPatientInsurances`;
                url += `?CustomerID=${invoice.patientID}`;

            return this.$http.get(url).then(({data}) => {
                    this.organizations = data;
                }).catch(() => {});
        },
        fetchFilteredInvoices() {
            this.$root.loading=true;
            let url = `AccountsReports/GetGroupedInvoicenPaymentsReport`;
                url += `?DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
                url += this.filter.search ? `&SearchText=${this.filter.search}`  : ``;

            return this.$http.get(url).then(response => {
                this.invoices = response.data.map(inv => {
                    return { ...inv, view: false, edit: false, };
                });
                this.$root.loading=false;
            }).catch(() => { this.$root.loading=false; });
        },
        fetchItemDetails(invoice) {
            this.$root.loading=true;
            let url = `AccountsReports/GetGroupedInvoicenPaymentsItemDetailsReport`;
            url += `?DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
            url += `&GroupId=${invoice.groupID}`;
             
            return this.$http.get(url).then(response => {
                this.itemdetails = response.data;
                this.$root.loading=false;
            }).catch(() => { this.$root.loading=false; });
        },
        fetchCombinedPayments(invoice) {

            const url = `Accounts/GetCombinedPaymentsnInvoicesDetails`;
            this.combinedInvoiceDetails= {
                combinedPaymentnInvoiceDetails: [],
                combinedPaymentnInvoiceItemsDetails: [],
            };
            this.$root.loading=true;
            return this.$http.get(`${url}?ReceiptnInvoiceNo=${invoice.receiptnInvoiceNo}`)
                .then(response => {
                    this.combinedInvoiceDetails = response.data;
                    this.$root.loading=false;
                }).catch(() => { this.$root.loading=false; });
        },
        printMpesaDetailsReceipt(receiptNo) {

window.open(
    `/reports/accounts-finance/mpesa-pay/print/${receiptNo}`, 
    '_blank', 
    `ReceiptDepositDetails`, 
    "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
},
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link :to="{name : `reports.accounts-finance.index` }">
                    Accounts & Finance Reports</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Invoices report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Departmental Report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <!-- <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search" 
                    id="grid-search" class="input-control input-sm text-xs">
              </div> -->
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" 
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.dateTo" 
                    id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="fetchFilteredInvoices">
                        <i class="fa fa-filter"></i> Filter</button>
              </div>
              <!-- <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button 
                    class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="$root.exportToExcel(`combined-invoices-report`, `invoicesReport`)">
                        <i class="fa fa-file-excel"></i> Export</button>
              </div> -->
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="invoicesReport">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny flex-1">Item Group</th>
                            <th class="p-tiny flex-1">Charges</th>
                            <th class="p-tiny flex-1">Cash Payment</th>
                            <th class="p-tiny flex-1">Insurance</th>
                            <th class="p-tiny flex-1">Waivered</th>
                            <th class="p-tiny flex-1">Action</th>
                            
                        </tr>
                  </thead>
                  <tbody class="text-xs bg-gray-100 flex flex-col 
                        items-center overflow-auto" 
                    style="max-height:65vh;">
                      <tr class="w-full flex" 
                        v-for="(invoice, idx) in invoices" :key="idx">
                          <td class="p-tiny flex-1">{{ invoice.groupName || `-` }}</td>
                          <td class="p-tiny flex-1">{{ invoice.totalCharges| numberFormat  }}</td>
                          <td class="p-tiny flex-1">{{ invoice.cashPayments| numberFormat  }}</td>
                          <td class="p-tiny flex-1">{{ invoice.insuranceAmount | numberFormat  }}</td>
                          <td class="p-tiny flex-1">{{ invoice.waiveredAmount | numberFormat }}</td>
                          
                          <td class="p-tiny flex-1">
                            <button title="Approve" 
                            @click.prevent="invoice.edit=true;fetchItemDetails(invoice)" 
                            class="btn-primary btn-sm text-xs rounded"><i class="fa fa-check"></i>Details</button>
                         <view-payment-details 
                         :invoice="invoice" 
                         :itemdetails="itemdetails" 
                         :showModal="invoice.edit" 
                             
                            @closeModal="invoice.edit=false">
                        </view-payment-details> 
                                    
                                
                                
                          </td>
                          <!--
                          <td class="p-tiny flex-1">
                              <button 
                                 
                                @click.prevent="printMpesaDetailsReceipt(invoice.receiptNo)"
                                class="btn-sm btn-info text-xs rounded">
                                    <i class="fa fa-eye"></i> View</button>
                                    
                                
                                
                          </td>-->
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>